/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.CustomerPageNavigationBlock
*/
export interface CustomerPageNavigationBlock extends NavigationBlock {
	
}
export const isCustomerPageNavigationBlock = (model: unknown): model is CustomerPageNavigationBlock => (model as CustomerPageNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.CustomerPageNavigationBlock';

